import { IntegrationType } from '@/shared/types/integration';

export const CHANNELS_WITHOUT_LIVE_CHAT: IntegrationType[] = [
  IntegrationType.FRONT,
  IntegrationType.SUNCO,
  IntegrationType.INTERCOM,
  IntegrationType.LIVECHAT,
  IntegrationType.ZENDESK,
  IntegrationType.TWILIO_VOICE,
  IntegrationType.TELNYX_VOICE,
];

export const CHANNELS_WITH_VOICE_MEMOS: IntegrationType[] = [
  IntegrationType.WHATSAPP,
  IntegrationType.WEB,
];
